import { WorkflowSidebarControlProps } from '../workflow-editor/hooks/use-sidear-control';

export const getSidebarViewConfig = (controller: WorkflowSidebarControlProps) => {
  const kind = controller.view.kind;
  const isEditing = kind !== 'library';

  const saveAction =
    kind === 'edit-existing' ? controller.saveExistingNode : controller.saveDraftNode;

  const closeAction = kind === 'edit-existing' ? controller.close : controller.backToLibrary;

  return { isEditing, saveAction, closeAction };
};
